import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../../Layout"
import { DiarioOcorrenciasForm } from "../../modais"

class DiarioOcorrenciasEditForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/diarioocorrencias")
  }
  render() {
    return (
      <Layout tabActive="Fiscalização">
        <DiarioOcorrenciasForm
          isEditing={true}
          callBackDiarioDeOcorrencia={this.onSuccess}
        />
      </Layout>
    )
  }
}
export default withRouter(DiarioOcorrenciasEditForm)



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/diario-ocorrencias/DiarioOcorrenciasEditForm.js